import maintenanceService from '../services';
import {
  setBannerDismissed,
  setMaintenanceInfo,
} from '../store-actions/maintenance-store-actions';
import { setDismissalToStorage } from '../utils/local-storage-utils';
import { createMaintenanceInfo } from '../utils/maintenance-utils';

export const loadMaintenance = async () => {
  const result = await maintenanceService.checkMaintenance.execute();
  if (!result) {
    return;
  }
  const info = createMaintenanceInfo(result);
  setMaintenanceInfo(info);
};

export const dismissBanner = () => {
  setBannerDismissed();
  setDismissalToStorage();
};
